import styled, { keyframes } from "styled-components";

const withAlpha = (color, alpha = "33") => {
  const value = String(color || "#2563eb").trim();

  if (/^#[0-9a-fA-F]{6}$/.test(value)) {
    return `${value}${alpha}`;
  }

  if (/^#[0-9a-fA-F]{3}$/.test(value)) {
    const [, red, green, blue] = value;
    return `#${red}${red}${green}${green}${blue}${blue}${alpha}`;
  }

  const opacity = Math.round((parseInt(alpha, 16) / 255) * 100);
  return `color-mix(in srgb, ${value} ${opacity}%, transparent)`;
};

const animation = keyframes`
    0%{
        opacity: 0;
        transform: translateY(25%);
    }
    100%{
        opacity: 1;
        transform: trabnslateY(0);
    }
`;

const addToCart = keyframes`
  0%{
    bottom: 50px;
    right: 100px;
  }
  50%{
    bottom: 50%;
    right: 50%;
  }
  100%{
    bottom: 75%;
    right: 85%;
  }
`;

export const StyledProducts = styled.div`
  display: flex;
  border-radius: 4px;
  width: 100%;
  font-size: 1rem !important;

  div {
    width: 100%;
  }

  .product-image {
    object-fit: cover;
    height: 100%;
    background: #fff;
    object-position: left;
    max-height: 100px;
    border-radius: ${(props) => props.rounded ? "10px" : "0px"}
  }

  .product-details {
    width: 100%;
    padding: 0px 15px;

    .product-title {
      line-height: 1.5em;
      max-height: 3em;
      overflow: hidden;
      font-size: 20px;
      font-weight: 700;
      color: ${(props) => props.primary_color};
    }
  }

  .radio-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
  }

  .margin {
    margin: 6px 0px;
    font-size: 16px;
    color: #3B444D;
  }

  @media (max-width: 800px) {
    font-size: 14px !important;
    height: 140px;

    .product-details {
      padding: 20px 12px;
      .product-title {
        font-size: 20px;
      }
    }

    .top-banner {
      display: none;
    }

    .product-image {
      margin-top: 20px;
      margin-left: 15px;
      border-radius: 6px;
      width: 100px;
      max-height: 120px;
    }

    .radio-buttons {
      display: none;
    }

    .margin {
      margin: 5px 0px;
    }
  }
`;

export const StyledComponentGroup = styled.div`
  position: relative;
  width: 100%;
  max-width: 700px;
  background: antiquewhite;
  border-radius: ${(props) => (props.rounded ? "10px" : "0px")};

  &.selected {
    border-bottom: 1px solid
      ${(props) => props.primary_color || "#11111133"};
  }

  .component-parent {
    display: flex;
    padding: 1rem 0;
  }

  .component-parent-image {
    object-fit: cover;
    object-position: left;
    border-radius: 4px;
    max-height: 150px;
    margin-left: 15px;
    margin-right: 15px;
    width: 120px;
  }

  .component-parent .product-details {
    padding: 0 15px;
    width: 100%;
  }

  .component-parent .margin {
    margin: 4px 0;
  }

  .component-action-buttons {
    margin: 0 3rem 1rem;
    padding-bottom: 0.5rem;
  }

  .component-action-buttons .button-container {
    justify-content: flex-start;
    width: 100%;
    gap: 12px;
  }

  .component-action-buttons .button-container .MuiButton-root {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .component-action-buttons .button-container .MuiButton-startIcon {
    margin-right: 8px;
  }

  .component-action-buttons .button-container .active {
    display: inline-flex;
  }

  .component-children {
    display: flex;
    flex-direction: column;
  }

  .component-child-message {
    margin: 0 3rem 0.75rem;
    color: #333333b2;
    font-size: 0.9rem;
  }

  .component-child {
    position: relative;
    margin: 0 3rem 1rem;
    padding: 1rem;
    background: rgb(255, 246, 234);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    cursor: pointer;
    transition: box-shadow 0.25s ease, transform 0.25s ease;
  }

  .component-child.selected {
    border-top-color: ${(props) => props.primary_color || "#11111133"};
  }

  .component-child.selectable:hover {
    box-shadow: 0px 10px 24px rgba(17, 17, 17, 0.12);
  }

  .component-child.disabled {
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }

  .component-child.disabled:hover {
    box-shadow: none;
  }

  .component-child .top-banner {
    background: #333;
    color: #fff;
    position: absolute;
    top: 0;
    left: 2rem;
    right: 2rem;
    padding: 4px 8px;
    font-size: 12px;
    margin: 0;
  }

  .component-child .child-body {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
  }

  .component-child .child-image {
    object-fit: cover;
    object-position: left;
    border-radius: 4px;
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background: #fff;
  }

  .component-child .child-info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .component-child .child-info .title {
    color: #333;
  }

  .component-child .child-info .margin {
    margin: 4px 0;
    color: #333333b2;
  }

  .component-child .child-info .price {
    font-weight: 700;
  }

  .component-child .info-message {
    padding: 1rem 0 0;
  }

  @media (max-width: 800px) {
    .component-parent {
      padding: 1rem 0;
    }

    .component-parent-image {
      margin-left: 15px;
      margin-right: 0;
      width: 100px;
      height: 120px;
    }

    .component-action-buttons {
      margin: 0 1.5rem 0.75rem;
      padding-bottom: 0.5rem;
    }

    .component-child-message {
      margin: 0 1.5rem 0.75rem;
      font-size: 0.85rem;
    }

    .component-child {
      padding: 1rem;
      margin: 0rem 1.5rem 1rem;
    }

    .component-child .top-banner {
      display: none;
    }

    .component-child .child-body {
      gap: 0.75rem;
    }

    .component-child .child-image {
      width: 80px;
      height: 80px;
    }
  }
`;

export const StyledProductsWrapper = styled.div`
  padding: ${(props) =>
    props.location === "/products"
      ? "100px 5.5% 100px 5.5%"
      : props.returnedProducts !== undefined &&
        props.returnedProducts.length > 0
        ? "20px 0px 100px 11%"
        : "25px 11% 0px"};

  .products-wrapper {
    width: ${(props) => (props.location === "/products" ? "50%" : "100%")};
    background: #fff;

    .select-products {
      background: transparent;
      padding: 0 0px 1rem;
      margin-bottom: 0;
      font-size: 20px;
      margin-top: ${(props) => props.returnedProducts.length > 0 ? "1rem" : "0px"};
      font-weight: 700;
      color: #3B444D;
    }

    .add-to-cart-image {
      position: absolute;
      z-index: 30;
      height: 50px;
      width: 50px;
      animation: ${addToCart} 700ms linear;
    }

    .products-return {
      margin-top: 7px;
    }
    .accordion {
      border-radius: 0px;
      .MuiAccordionDetails-root {
        padding: 0px;
      }
    }

    .cart-wrapper {
      border-bottom: ${(props) =>
    props.outOfStock !== undefined &&
      props.outOfStock !== null &&
      props.returnedProducts
        .filter((a) => a.variant_id)
        .indexOf(props.outOfStock)
      ? `1px solid red`
      : "1px solid #11111133"};
      border-radius: 4px;

      .exchange-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;

        .mob-ex-divider {
          display: none;
        }

        .exchange-box {
          display: flex;
          padding: 0px 0px;
          border-radius: 4px;
          flex-direction: column;
          flex: 0.45;

          .mob-ex {
            font-size: 16px;
            margin: 0px 0px 10px;
            color: #333;
            font-weight: 500;
          }

          .return-label {
            font-size: 12px;
            color: #fff;
            position: absolute;
            top: -1rem;
            right: -1rem;
            padding: 2px 10px 4px;
            border-top-right-radius: 8px;
            border-bottom-left-radius: 8px;
          }

          .upto-refund,
          .conditions {
            font-size: 16px;
          }

          .image-preview-container {
            width: 100%;
            max-width: 60px;
            height: 60px;
            overflow: hidden;
            margin-top: 10px;
          }

          .image-preview {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 4px;
          }

          .description,
          .quantity {
            font-size: 16px;
            margin: 10px 0;
            color: #3B444D;
          }

          .title,
          .price {
            margin: 10px 0;
            font-weight: 700;
          }

          .title {
            font-size: 18px;
            color: ${(props) => props.primary_color};
          }

          .price {
            font-size: 16px;
            color: #3B444D;
          }

          .stock {
            color: red;
            margin-left: auto;
          }

          .details {
            padding: 0px 0px;
            position: relative;
            width: 100%;
            margin-left: 0;
          }
        }

        .return-icon {
          display: flex;
          align-items: center;
          flex: 0.1;
          margin: 0 1rem;
          justify-content: center;
          height: 100%;

          svg {
            position: relative;
            top: 0;
          }
        }

        .return-item-box {
          margin-top: 0rem;
        }
      }

      .return-type,
      .return-reason {
        font-size: 1rem;
      }
    }

    .button-container {
      display: flex;
      justify-content: center;
      margin: 0.5rem 0rem 4px;
      flex-wrap: wrap;
      gap: 10px;

      .rms-btns {
        font-size: 1rem;
        .charges-statement {
          font-size: 10px;
          color: #f1416c;
          white-space: nowrap;
        }
      }
    }

    .track-request-container {
      margin-top: 0;
    }

    .expiry-info {
      padding: 0.75rem 1rem;
      margin: 0.5rem 0;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      background: ${(props) => `color-mix(in srgb, ${props.primary_color} 15%, white)`};

      p {
        margin: 0;
        display: flex;
        align-items: center;
        color: #3B444D;
        font-weight: 700;

        svg {
          margin-right: 4px;
        }
      }
    }

    .incentivise-message {
      padding: 0 0rem 10px;
      font-weight: 700;
      font-size: 14px;
      margin: 0px;
    }

    .info-message {
      color: #963d1f;
      font-size: 14px;
      padding: 1rem;
      margin: 10px 0px;
      borderRadius: ${(props) => props.rounded ? "10px" : "0px"};
      background: #fffbeb;
      border: 1px solid #fee686;
    }

    .mob-view-cart-btn {
      position: fixed;
      bottom: ${(props) => (props.location === "/products" ? "30px" : "40px")};
      left: 0;
      width: 100%;
      z-index: 20;
      background: #fff;
      padding: 10px 0px;
      box-shadow: 0px -3px 0px rgba(0, 0, 0, 0.1);

      button {
        margin: 10px 30px 0px auto;
        max-width: 400px;
        padding: 10px 0px;
        display: flex;
      }
    }
  }

  .products-skeleton {
    display: flex;
    width: ${(props) => (props.location === "/products" ? "45%" : "100%")};
    border: 1px solid rgba(17, 17, 17, 0.2);
    margin-left: ${(props) =>
    props.location === "/products" ? "40px" : "0px"};
    margin-top: 40px;

    .image-skeleton {
      width: 220px;
      height: 220px;
    }

    .text-skeleton {
      width: 250px;
      margin-top: 10px;
    }
  }
  .select {
    font-size: 1rem;
    color: #3b444d;
    margin: 20px 0px;
    font-weight: 700;
  }

  .button-container .active {
    display: inline-flex;
  }

  @media (max-width: 800px) {
    padding: ${(props) =>
    props.location === "/products" && props.returnedProducts.length > 0
      ? "110px 0px 20px"
      : props.location === "/products"
        ? "60px 0px 20px"
        : "10px 0px 20px"};

    .products-grid {
      padding: 1rem;
    }

    .products-wrapper {
      width: 100%;

      .products-return {
        margin-top: 0px;
      }

      .select-products {
        padding: 1rem 1rem 0rem 30px;
        font-size: 16px;
        font-weight: 400;
      }

      .accordion {
        position: fixed;
        z-index: 10;
        width: 100%;
        top: 60px;
      }

      .button-container {
        display: flex;
        justify-content: center;
        margin: 20px 1rem 10px;
        flex-wrap: wrap;
        gap: 10px;

        .rms-btns {
          font-size: 14px;
          .charges-statement {
            font-size: 9px;
          }
        }
      }

      .track-request-container {
        margin-top: 0;
      }

      .expiry-info {
        background: #f8f4f0;
        border-radius: 4px;
        padding: 0.5rem 1rem;
        margin: 0 1rem 0.5rem;

        p {
          margin: 0;
          display: flex;
          align-items: center;

          svg {
            margin-right: 4px;
          }
        }
      }

      .incentivise-message {
        padding: 0 1rem 10px;
      }

      .info-message {
        font-size: 12px;
        padding: 1rem;
      }

      .cart-wrapper {
        border-bottom: none;
        .exchange-wrapper {
          flex-direction: column;

          .mob-ex-divider {
            display: block;
          }

          .return-item-box {
            margin-top: 0.5rem;
          }

          .exchange-box {
            flex-direction: row;

            .details {
              margin-left: 1rem;
            }

            .mob-ex,
            .upto-refund,
            .conditions,
            .description,
            .quantity {
              margin: 7px 0px;
            }
            .title,
            .price {
              font-weight: 700;
              margin: 7px 0px;
            }
          }

          .return-icon {
            margin: 10px 0px;
            justify-content: center;
            height: 100%;

            svg {
              position: absolute;
              top: -14px;
            }
          }
        }

        .return-type,
        .return-reason {
          font-size: 16px;
        }
      }

      .mob-view-cart-btn {
        display: flex;
        position: fixed;
        bottom: 20px;
        margin-bottom: 1rem;
        width: 100%;
        box-shadow: none;
        padding: 0;

        button {
          margin: 0px 1rem;
          padding: 10px 0px;
          max-width: 100%;
        }
      }
    }

    .select,
    .help {
      padding: 0px 15px;
    }

    .select {
      font-size: 14px;
      margin: 0px;
      margin-bottom: 12px;
    }

    .products-skeleton {
      width: 90%;
      margin-left: 20px;
      margin-top: 20px;

      .image-skeleton {
        width: 140px;
        height: 140px;
      }

      .text-skeleton {
        width: 120px;
        margin-top: 0px;
      }
    }
  }
`;

export const StyledMobButtons = styled.div`
  padding: 0px 1rem;
  @media (min-width: 800px) {
    display: none;
  }
`;

export const StyledReasonWrapper = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #11111133;
  overflow: hidden;
  height: 90vh;
  background: #fff;
  border-radius: ${(props) => (props.rounded ? "10px 10px 0px 0px" : "0px")};

  .reason-panel-header {
    flex: 0 0 auto;
  }

  .reason-scroll-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: ${(props) => (props.openFilter ? "hidden" : "auto")};
    overscroll-behavior: contain;
  }

  .product_title {
    font-size: 20px;
    color: ${props => props.primary_color};
    font-weight: 700;
  }

  .reason-form {
    font-size: 16px;
    padding: 10px 20px;

    .choose-reason-statement {
      font-size: 16px;
      font-weight: 700;
      color: #3B444D;
      margin: 10px 0px 0px;
    }
  }

  .reasons {
    display: ${(props) =>
    props.selectedReason && props.selectedReason !== null ? "none" : "block"};
  }

  .preference {
    margin: 10px 0px 5px !important;
  }

  .different-skeleton {
    min-width: 150px;
    max-width: 400px;
    .diif-image {
      width: 100%;
    }
  }

  .diff-prod-buttons {
    .exchange-button-web {
      display: none;
    }

    .exchange-button-mob {
      display: block;
      position: fixed;
      z-index: 25;
      bottom: 0;
      overflow: hidden;
      width: 100%;
    }

    .back-button {
      display: none;
    }
  }

  .collections-section {
    padding: 0px 0px 5px 1rem;
    overflow: auto;
    margin-right: 1rem;
    display: flex;

    ::-webkit-scrollbar {
      height: 2px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.primary_color};
    }
  }

  .proceed-btn {
    display: flex;
    flex: 0 0 auto;
    margin: 0;
    position: relative;
    width: 100%;
    padding: 12px;
    border-radius: 0px;
    z-index: 20;
  }

  .media-upload {
    margin-top: 14px;
  }

  .media-upload-guidelines-title {
    margin: 0 0 6px;
    color: rgb(59, 68, 77);
    font-size: 14px;
    font-weight: 500;
  }

  .media-upload-guideline-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .media-upload-guideline {
    flex: 0 0 calc(50% - 5px);
    min-width: min(100%, 240px);
    padding: 26px 12px 18px;
    overflow: hidden;
    border: 1px solid
      ${(props) => withAlpha(props.primary_color, "40")};
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: ${(props) => withAlpha(props.primary_color, "14")};
    box-sizing: border-box;
    text-align: center;
  }

  .media-upload-guideline.has-error {
    border-color: #d92d20;
    background: #fff5f4;
  }

  .media-upload-guideline-label {
    min-height: 24px;
    margin: 5px 2px 0;
    color: rgb(59, 68, 77);
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    overflow-wrap: anywhere;
  }

  .media-upload-guideline-previews {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .media-upload-input {
    display: none;
  }

  .media-upload-guideline-preview {
    position: relative;
    width: 108px;
    height: 108px;
    overflow: hidden;
    border: 1px solid ${(props) => props.primary_color}33;
    border-radius: 50%;
    background: #fff;
  }

  .media-upload-guideline-preview img,
  .media-upload-guideline-preview video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-previews {
    width: 100%;
    display: block;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-preview {
    width: 100%;
    height: 190px;
    margin: 0;
    border: 0;
    border-bottom: 1px solid #d9e0ea;
    border-radius: 0 !important;
    background: #fff;
    box-sizing: border-box;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-label {
    min-height: 0;
    margin: 12px 14px 0;
  }

  .media-upload-guideline.has-preview {
    padding: 0;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-preview img,
  .media-upload-guideline.has-preview .media-upload-guideline-preview video {
    display: block;
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
    background: #fff;
    border-radius: 0 !important;
  }

  .media-upload-guideline.has-preview
    .media-upload-guideline-instruction {
    min-height: 0;
    margin: 5px 14px 16px;
  }

  .media-upload-guideline-preview button {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 50%;
    background: rgba(17, 24, 39, 0.68);
    cursor: pointer;
  }

  .media-upload-guideline-preview button svg {
    width: 11px;
    height: 11px;
    stroke: #fff;
  }

  .media-upload-guideline-add {
    position: relative;
    width: 112px;
    height: 132px;
    margin: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border: 0;
    background: transparent;
    color: ${(props) => props.primary_color};
    cursor: pointer;
  }

  .media-upload-guideline-add::before {
    content: "";
    position: absolute;
    top: 0;
    width: 108px;
    height: 108px;
    border: 1px solid ${(props) => props.primary_color}33;
    border-radius: 50%;
    background: ${(props) => props.primary_color}0d;
    box-sizing: border-box;
  }

  .media-upload-guideline-add > svg {
    position: absolute;
    top: 29px;
    width: 48px;
    height: 48px;
    z-index: 1;
  }

  .media-upload-guideline-add > small {
    position: absolute;
    bottom: 0;
    width: 112px;
    color: ${(props) => props.primary_color};
    font-size: 12px;
    font-weight: 700;
  }

  .media-upload-guideline-instruction {
    min-height: 34px;
    margin: 4px 2px 0;
    color: #4b5565;
    font-size: 12px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .media-upload-guideline-error {
    margin: 6px 0 0;
    color: #d92d20;
    font-size: 11px;
    font-weight: 700;
  }

  .media-upload-guideline,
  .media-upload-guideline.has-preview {
    min-height: 82px;
    padding: 10px 12px !important;
    display: grid;
    grid-template-columns: 76px minmax(0, 1fr);
    align-items: center;
    gap: 12px;
    text-align: left;
  }

  .media-upload-guideline:not(.has-error) {
    border: 1px solid
      ${(props) => withAlpha(props.primary_color, "40")};
    background: ${(props) => withAlpha(props.primary_color, "14")};
  }

  .media-upload-card-media {
    min-width: 0;
    min-height: 60px;
    padding-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid ${(props) => props.primary_color}26;
    box-sizing: border-box;
  }

  .media-upload-guideline .media-upload-guideline-previews,
  .media-upload-guideline.has-preview .media-upload-guideline-previews {
    width: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .media-upload-guideline .media-upload-guideline-add {
    width: 58px;
    height: 58px;
  }

  .media-upload-guideline .media-upload-guideline-add::before {
    width: 58px;
    height: 58px;
  }

  .media-upload-guideline .media-upload-guideline-add > svg {
    top: 14px;
    width: 30px;
    height: 30px;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-preview {
    width: 58px;
    height: 66px;
    border: 0;
    border-radius: ${(props) => (props.rounded ? "6px" : "0px")} !important;
    overflow: visible;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-preview img,
  .media-upload-guideline.has-preview .media-upload-guideline-preview video {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    border-radius: inherit !important;
  }

  .media-upload-guideline.has-preview .media-upload-guideline-preview img {
    cursor: zoom-in;
  }

  .media-upload-guideline-preview button {
    top: -6px;
    right: -6px;
  }

  .media-upload-card-copy {
    min-width: 0;
  }

  .media-upload-kind {
    margin: 0 0 5px;
    color: ${(props) => props.primary_color};
    font-size: 10px;
    font-weight: 800;
  }

  .media-upload-guideline .media-upload-guideline-label,
  .media-upload-guideline.has-preview .media-upload-guideline-label {
    min-height: 0;
    margin: 0;
    color: rgb(59, 68, 77);
    font-size: 10px;
    font-weight: 600;
  }

  .media-upload-guideline .media-upload-guideline-instruction,
  .media-upload-guideline.has-preview .media-upload-guideline-instruction {
    min-height: 0;
    margin: 4px 0 0;
    color: rgb(52, 64, 84);
    font-size: 10px;
    line-height: 1.35;
  }

  .media-upload-tips {
    margin-top: 12px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    border: 1px solid ${(props) => props.primary_color}26;
    border-radius: ${(props) => (props.rounded ? "8px" : "0px")};
    background: ${(props) => props.primary_color}0d;
    color: #344054;
    font-size: 10px;
    line-height: 1.35;
  }

  .media-upload-tips > svg {
    width: 19px;
    height: 19px;
    flex: 0 0 auto;
    color: ${(props) => props.primary_color};
  }

  .media-upload-tips > strong {
    flex: 0 0 auto;
    color: ${(props) => props.primary_color};
    font-size: 11px;
    text-transform: uppercase;
  }

  .media-upload-tips > span {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .media-image-preview-modal {
    position: fixed;
    inset: 0;
    z-index: 10000;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.76);
    box-sizing: border-box;
  }

  .media-image-preview-dialog {
    position: relative;
    width: min(92vw, 720px);
    max-height: 88vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .media-image-preview-dialog img {
    max-width: 100%;
    max-height: 88vh;
    object-fit: contain;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
  }

  .media-image-preview-dialog button {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 50%;
    background: rgb(59, 68, 77);
    cursor: pointer;
  }

  .media-image-preview-dialog button svg {
    width: 14px;
    height: 14px;
    stroke: #fff;
  }

  .media-upload-slow-note {
    margin-top: 10px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    background: #fff8dd;
    color: #344054;
    font-size: 12px;
  }

  @media (max-width: 520px) {
    .media-upload-guideline-list {
      grid-template-columns: minmax(0, 1fr);
      gap: 10px;
    }

    .media-upload-guideline {
      padding: 22px 8px 14px;
    }

    .media-upload-guideline.has-preview {
      padding: 0;
    }


    .media-upload-tips {
      padding: 10px;
      gap: 7px;
    }
  }

  @media (min-width: 800px) {
    animation: ${animation} 1s linear;
    max-width: 600px;
    margin: auto;
    height: 70vh;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};

    .reason-form, .rms-btns {
      font-size: 16px;
    }
    .charges-statement {
      font-size: 8px;
    }
    .preference {
      margin: 20px 0px;
    }
    .product_title {
      font-size: 20px;
    }

    .diff-prod-buttons {
      .exchange-button-web {
        width: 80%;
        display: flex;
        padding: 12px;
        z-index: 10;
      }

      .exchange-button-mob {
        display: none;
      }

      .back-button {
        display: block;
        padding: 12px;
        width: 20%;
        border-radius: 0px;
      }
    }

    .proceed-btn {
      position: relative;
      width: 100%;
      max-width: 600px;
    }
  }
`;

export const StyledDifferentProduct = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;

  .image-container {
    width: 100%;
    height: 300px;
    object-fit: contain;
    justify-content: center;
    display: flex;
  }

  span {
    height: inherit;
  }

  .product-image {
    height: 100%;
    border-radius: 0px;
    margin: 0px;
  }

  .product-details {
    width: 100%;
    margin-left: 0px;
    padding: 1rem 1rem 0px;

    .product-title {
      margin: 6px 0px;
      font-size: 20px;
      font-weight: 700;
    }
  }

  @media (min-width: 800px) {
    flex-direction: row;
    padding: 10px 20px;

    .image-container {
      width: auto;
      height: auto;
      margin-top: 10px;
      max-height: 200px;
      margin-top: 5px;
    }

    .product-image {
      width: 150px;
      height: 100%;
      max-height: 200px;
      border-radius: 4px;
      object-fit: contain;
    }

    .product-details {
      margin-left: 6px;
      padding: 0px 1rem;

      .product-title {
        font-size: 20px;
      }
    }
  }
`;

export const StyledOpenFilter = styled.div`
  position: fixed;
  background: #fff;
  width: 100%;
  bottom: 0px;
  z-index: 99;
  height: calc(90vh - 60px);

  .filter-attributes {
    width: 35%;
    height: calc(90vh - 180px);
    overflow: auto;
  }

  .filter-attribute-values {
    width: 65%;
    padding: 0px 1rem;
    height: calc(90vh - 180px);
    overflow: auto;
  }

  @media (min-width: 800px) {
    height: calc(70vh - 68px);
    max-width: 598px;
    bottom: initial;

    .filter-attributes {
      width: 25%;
      height: calc(85vh - 300px);
    }

    .filter-attribute-values {
      width: 75%;
      height: calc(85vh - 300px);
    }
  }
`;

export const StyledVariantSelect = styled.div`
  padding: 0px 1rem 60px;

  @media (min-width: 800px) {
    padding: 0px 20px 60px;
  }
`;
